import React, { useEffect, useRef, useState } from 'react';

import { IEquipmentLabel } from '@r1-frontend/api-domru/full-buy/v1/equipment/dto/EquipmentLabel.dto';

import { useMatchMedia } from '@r1-frontend/shared/hooks/useMatchMedia';

import SliderControls from './SliderControls';

import * as ST from './styled';

export interface ISlider {
    images?: string[],
    title?: string,
    labels?: IEquipmentLabel[],
}

export interface IControlsCallback {
    goToSlide: (index: number) => void,
    currentSlide: number,
}

enum EMediaWidth {
    mobile = '(max-width: 767px)',
}

const Slider = ({ images, title, labels }: ISlider) => {
    const isMobile = useMatchMedia(EMediaWidth.mobile);
    const swiperRef = useRef<HTMLInputElement | null>(null);
    const [props, setProps] = useState({});

    useEffect(() => {
        if (isMobile) {
            setProps({});
        } else {
            setProps({
                renderBottomCenterControls: ({ goToSlide, currentSlide }: IControlsCallback) => {
                    return <ST.CaruselContainer>
                        <SliderControls
                            images={images || []}
                            activeImageIndex={currentSlide}
                            onClick={(index: number) => {
                                goToSlide(index);
                            }}
                        />
                    </ST.CaruselContainer>;
                },
            });
        }
    }, [isMobile, images]);

    return (
        <ST.FullPreviewWrapper>
            {labels && <ST.LabelsContainer>
                {
                    labels.map(label => {
                        return (<ST.StyledLabel key={label.id} bgColor={label.color} textColor={label.colorText}>
                            {label.title}
                        </ST.StyledLabel>);
                    })
                }
            </ST.LabelsContainer>}
            {images &&
                <ST.FullPreviewContainer>
                    <ST.StyledNukaCarousel
                        withoutArrows={true}
                        autoplay={images.length > 1}
                        disableEdgeSwiping={true}
                        innerRef={swiperRef}
                        withoutDots={!isMobile}
                        wrapAround={true}
                        dragging={images.length > 1}
                        {...props}
                    >
                        {
                            images.map((url) => (<ST.ImageContainer key={url}>
                                {isMobile
                                    ? <ST.Image src={url} alt={title} />
                                    : <ST.FullPreview src={url} alt={title} />
                                }
                            </ST.ImageContainer>))
                        }
                    </ST.StyledNukaCarousel>
                </ST.FullPreviewContainer>
            }
        </ST.FullPreviewWrapper>
    );
};

export default Slider;
